const local = {
  info: {
    REACT_APP_WEBSITE_URL: "https://www.agentscrum.ai",
  },
  bookdemo: {
    Link: "https://agentscrum-bookdemo.stage.neuralcompany.team",
  },
};

const dev = {
  auth: {
    REACT_APP_AUTH_URL: "https://akira-ai-auth.stage.neuralcompany.team/api/auth",
  },
  app: {
    WORKSPACE_DOMAIN_NAME: ".neuralcompany.team",
  },
  info: {
    REACT_APP_WEBSITE_URL: "https://www.agentscrum.ai",
  },
  bookdemo: {
    Link: "https://agentscrum-bookdemo.stage.neuralcompany.team",
  },
};

const prod = {
  auth: {
    REACT_APP_AUTH_URL: "https://app.akira.ai/api/auth",
  },
  app: {
    WORKSPACE_DOMAIN_NAME: ".akira.ai",
  },
  info: {
    REACT_APP_WEBSITE_URL: "https://www.agentscrum.ai",
  },
  bookdemo: {
    Link: "https://demo.akira.ai/agentscrum/",
  },
};

const config =
  process.env.REACT_APP_STAGE === "production"
    ? prod
    : process.env.REACT_APP_STAGE === "development"
    ? dev
    : local;

// eslint-disable-next-line
export default {
  ...config,
};
